module.exports = __webpack_public_path__ + "img/bank-input.3532848c.png";